import React from 'react';

const HintIcon = ({ color = "#0D3B66", ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" { ...rest }>
      <path d="M9.99935 1.66699C5.39935 1.66699 1.66602 5.40033 1.66602 10.0003C1.66602 14.6003 5.39935 18.3337 9.99935 18.3337C14.5993 18.3337 18.3327 14.6003 18.3327 10.0003C18.3327 5.40033 14.5993 1.66699 9.99935 1.66699ZM10.8327 14.167H9.16602V9.16699H10.8327V14.167ZM10.8327 7.50033H9.16602V5.83366H10.8327V7.50033Z" fill={color} />
    </svg>
  );
};

export default HintIcon;